<template>
  <div class="upload-media">
    <b-card class="card-upload">
      <div class="row">
        <div class="col-12 alert">
          <b-alert
            v-height-fade.appear
            variant="danger"
            :show="displayMaxFileAlert"
            class="alert-header"
          >
            <div class="alert-body">
              <feather-icon icon="InfoIcon" class="mr-50" />
              <span v-html="$t('MEDIA_LIBRARY.Alert_Limit')"></span>
              <span v-html="$t('MEDIA_LIBRARY.Alert_Extensions')"></span>
            </div>
          </b-alert>
          <b-alert
            v-height-fade.appear
            variant="danger"
            :show="displayMaxFileSendNewsAlert"
            class="alert-header"
          >
            <div class="alert-body">
              <feather-icon icon="InfoIcon" class="mr-50" />
              <span v-html="$t('MEDIA_LIBRARY.Alert_Limit_Sendnews')"></span>
              <span v-html="$t('MEDIA_LIBRARY.Alert_Extensions')"></span>
            </div>
          </b-alert>
          <b-alert
            v-height-fade.appear
            variant="danger"
            :show="displayMaxSizeFileAlert"
            class="alert-header"
          >
            <div class="alert-body">
              <feather-icon icon="InfoIcon" class="mr-50" />
              <span v-html="$t('MEDIA_LIBRARY.Alert_Limit_Media_Size')"></span>
            </div>
          </b-alert>
        </div>
      </div>

      <b-row>
        <b-col cols="9" class="pr-0 media-gallery">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="3" style="display: none">
                <div class="form-label-group">
                  <b-form-input
                    id="id"
                    placeholder="ID"
                    v-model="form._id"
                    disabled
                  />
                  <label for="id">ID</label>
                </div>
              </b-col>
              <div class="drag-files" @dragover="dragover" @dragleave="dragleave" @drop="drop">
                <span class="text-upload">{{$t('MEDIA_LIBRARY.Drag_Drop_Text')}}</span
                >
                <b-button
                  aria-controls="sidebar-add-new-event"
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  variant="flat-primary btn-upload"
                  class="btn-icon"
                  block
                  @click="openSelectFile"
                >
                  <feather-icon icon="UploadIcon" />
                </b-button>
                <span class="text-btn">{{$t('MEDIA_LIBRARY.Select')}}</span>
                <input
                  type="file"
                  ref="file-image"
                  accept=".png, .jpg, .jpeg, .doc, .docx, .xls, .xlsm, .xlsx, .pdf, .mp3, .gif, .mp4, .wav, .ogg, .aac"
                  style="display: none"
                  :multiple="!isUpdate"
                  @change="onSelectedFileImage"
                />
              </div>

              <b-col md="12" v-if="form.image_path && files.length == 0">
                <img :src="form.image_path" class="image-gallery" />
              </b-col>
              <b-col md="12" class="results-import">
                <div v-for="(item, index) in files" :key="index">
                  <img
                    :src="getFilePath(item)"
                    class="image-gal img-thumbnail img-fluid upload-result"
                  />
                  
                  <b-button
                    variant="flat-danger"
                    class="btn-icon rounded-circle btn-image-delete"
                    @click.prevent="onRemoveImage(item)"
                  >
                    <feather-icon icon="TrashIcon" />
                  </b-button>
                </div>
              </b-col>
              <!-- <b-col md="1"> </b-col> -->
              <b-col md="12" style="padding: 10px 0px"></b-col>

              <!-- <b-col md="6">
            <div class="form-label-group">
              <b-form-input
                id="filename"
                placeholder="Nome do arquivo"
                v-model="form.filename"
                disabled
              />
              <label for="filename">Nome do Arquivo</label>
            </div>
          </b-col> -->

              <b-col md="12" style="display: none"><hr /></b-col>
              <b-col md="3" style="display: none">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.dt_create"
                    disabled
                    style="display: none"
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="3" style="display: none">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="3" style="display: none">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-updated"
                    placeholder="Data atualização"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt-updated">Data atualização</label>
                </div>
              </b-col>
              <b-col md="3" style="display: none">
                <div class="form-label-group">
                  <b-form-input
                    id="email-updated"
                    placeholder="Email atualização"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email-updated">Email atualização</label>
                </div>
              </b-col>
              <b-col cols="12" style="display: none">
                <b-form-group>
                  <b-form-checkbox
                    id="active"
                    name="active"
                    v-model="form.active"
                  >
                    Ativo
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col cols="3" class="pr-2 media-details">
          <div class="alert-body">{{$t('MEDIA_LIBRARY.Alert_Body')}}.</div>
          <b-card class="card-form">
            <b-col md="12" v-if="displayCompressPDF">
              <b-form-group>
                <span>{{$t('MEDIA_LIBRARY.Compress_PDF')}}</span>
                <b-form-checkbox
                  name="check-button"
                  class="config-post-swiches"
                  switch
                  inline
                  v-model="compressPdf"
                >
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <b-form-group>
                <span>{{$t('MEDIA_LIBRARY.Tags')}}</span>
                <v-select
                  id="tag-list"
                  :placeholder="$t('MEDIA_LIBRARY.Tags')"
                  v-model="form.tags"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  label="name"
                  multiple
                  taggable
                  :closeOnSelect="false"
                  push-tags
                >
                  <!-- <span slot="no-options">{{ $t("GENERAL.NoOptions") }}</span> -->
                </v-select>
              </b-form-group>
            </b-col>
            <b-col md="12">
              <div class="form-label-group">
                <span>{{$t('MEDIA_LIBRARY.Copyright_Label')}}</span>
                <b-form-textarea
                  id="copyright"
                  :placeholder="$t('MEDIA_LIBRARY.Copyright')"
                  v-model="form.copyright"
                  spellcheck="true"
                  rows="2"
                />
                <!-- <b-form-input
                id="copyright"
                placeholder="Copyright"
                v-model="form.copyright"
              /> -->
                <label for="copyright">{{$t('MEDIA_LIBRARY.Copyright')}}</label>
              </div>
            </b-col>
            <!-- <b-col md="12">
              <div class="form-label-group">
                <b-form-group label="Tipo de midia" label-for="subject-list">
                  <v-select
                    id="image-type-list"
                    v-model="form.image_type"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="image_type"
                  >
                    <span slot="no-options">{{$t('GENERAL.NoOptions')}}</span>
                  </v-select>
                </b-form-group>
              </div>
            </b-col> -->
            <b-col md="12" class="buttons-details">
              <b-button
                @click="$emit('back')"
                variant="flat-primary"
                size="sm"
              >
                {{$t('MEDIA_LIBRARY.Back')}}
              </b-button>
              <b-button
                type="submit"
                variant="primary"
                        size="sm"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                @click="submit"
              >
                {{!sendNews ? $t('MEDIA_LIBRARY.Send') : $t('MEDIA_LIBRARY.Insert_Media')}}
              </b-button>
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BFormTextarea,
  BButton,
  BCard,
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BAlert,
} from "bootstrap-vue";
import vSelect from "vue-select";
import useImageLibRegister from "./useImageLibRegister";
import AppConstants from "@/appConstants";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import { heightFade } from '@core/directives/animations'
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

let self;

export default {
  components: {
    BAlert,
    BFormTextarea,
    BButton,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormInput,
    BFormGroup,
    vSelect,
    FeatherIcon,
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },
  props: {
    sendNews: {
      type: Boolean,
      require: true,
    },
    selectedTags: {
      type: Array
    }
  },
  mounted() {
    // console.log("created");
    self = this;
    if (this.sendNews && this.selectedTags) {
      if (this.selectedTags.length > 0) {
        this.form.tags = this.selectedTags.map(item => {
          if (item.name) {
            return item.name;
          }
          return item;
        });
      }
    }
    this.fetchDetail(self);
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      event.currentTarget.classList.add('bg-dragover');
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.remove('bg-dragover');
    },
    drop(event) {
      event.preventDefault();
      this.onSelectedFileImage(event);
      this.dragleave(event);
    },
    getFilePath(data) {
      const extension = data.file.name.substring(
        data.file.name.indexOf(".") + 1
      ).toLowerCase();
      if (AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(extension) >= 0
          || AppConstants.MEDIA_AUDIO_EXTENSIONS.indexOf(extension) >= 0
          || AppConstants.MEDIA_VIDEO_EXTENSIONS.indexOf(extension) >= 0) {
        const doc = AppConstants.MEDIA_DOCUMENT_TYPE.find(
          (item) => item.values.indexOf(extension) >= 0
        );
        if (doc) {
          return require(`@/assets/images/icons/${doc.img_name}`);
        }
      }
      return data.image_path;
    },
    backPage() {
      this.onBackPage(self);
    },
    submit() {
      if (this.sendNews) {
        if (this.files.length == 0) {
          messagesNotifyHelper.warningNotify('Media', this.$t('MEDIA_LIBRARY.Image_Drop_Placeholder'));
          return;
        }
        const data = {};
        for (let index = 0; index < this.files.length; index++) {
          const extension = this.files[index].file.name.substring(this.files[index].file.name.indexOf('.') + 1).toLowerCase();
          if (AppConstants.MEDIA_DOCUMENT_EXTENSIONS.indexOf(extension) >= 0) {
            data.newDocument = {};
            data.newDocument.file = this.files[index].file;
            data.newDocument.tags = this.form.tags;
            data.newDocument.copyright = this.form.copyright;
            data.newDocument.extension = extension;
            data.newDocument.compressPdf = this.compressPdf;
          } else if (AppConstants.MEDIA_AUDIO_EXTENSIONS.indexOf(extension) >= 0) {
            data.newAudio = {};
            data.newAudio.file = this.files[index].file;
            data.newAudio.tags = this.form.tags;
            data.newAudio.copyright = this.form.copyright;
            data.newAudio.extension = extension;
          } else if (AppConstants.MEDIA_VIDEO_EXTENSIONS.indexOf(extension) >= 0) {
            data.newVideo = {};
            data.newVideo.file = this.files[index].file;
            data.newVideo.tags = this.form.tags;
            data.newVideo.copyright = this.form.copyright;
            data.newVideo.extension = extension;
          } else {
            data.newImage = {};
            data.newImage.file = this.files[index].file;
            data.newImage.image_path = this.files[index].image_path;
            data.newImage.tags = this.form.tags;
            data.newImage.copyright = this.form.copyright;
            data.newImage.extension = extension;
          }
        }
        this.$emit('select-new-image', data);
      } else {
        this.onSubmit(self);
      }
    },
  },
  setup() {
    const openSelectFile = () => {
      self.$refs["file-image"].click();
    };

    const onSelectedFileImage = (event, paste) => {

      let currentFiles = null;
      if (!paste) {
        if (event.target.files) {
          currentFiles = Array.from(event.target.files);
        } else if (event.dataTransfer.files) {
          currentFiles = Array.from(event.dataTransfer.files);
        }
      } else if (paste.size) {
        currentFiles = [paste]
      } else {
        return;
      }

      currentFiles.forEach(file => {
        const totalSize = file.size / 1024 / 1024;

        if (file.type === 'video/mp4') {
          if (totalSize > AppConstants.MEDIA_VIDEO_MAX_SIZE) {
            displayMaxSizeFileAlert.value = true;
          }
        } else {
          if (totalSize > AppConstants.MEDIA_MAX_SIZE) {
            displayMaxSizeFileAlert.value = true;
          }
          if (totalSize > 1) { // Acima de 1 MB
            compressPdf.value = true;
          }
        }
      })

      if (displayMaxSizeFileAlert.value) return;
      
      if (!self.sendNews) {
        if (currentFiles.length > 20) {
          displayMaxFileAlert.value = true;
          return;
        } 
      } else {
        if (currentFiles.length > 2) {
          displayMaxFileSendNewsAlert.value = true;
          return;
        }
        if (!currentFiles[0].name) {
          return;
        }
        const extension = currentFiles[0].name.substring(currentFiles[0].name.indexOf('.') + 1);
        let findedExtension = false;
        for (let index = 1; index < currentFiles.length; index++) {
          if (currentFiles[index].name.substring(currentFiles[index].name.indexOf('.') + 1).toLowerCase() == extension.toLowerCase()) {
            findedExtension = true;
          }
        }
        if (findedExtension) {
          console.log('inserido mais que dois arquivos da mesma extensao');
        }
      }

      displayMaxFileAlert.value = false;
      displayMaxFileSendNewsAlert.value = false;
      // console.log("onSelectedFileImport");
      for (let index = 0; index < currentFiles.length; index++) {
        if (!self.sendNews) {
          if (files.value.length < 20) {
            files.value.push({
              file: currentFiles[index],
              image_path: URL.createObjectURL(currentFiles[index]),
            });
          }
        } else {
          if (files.value.length < 2) {
            const fileExtension = currentFiles[index].name.substring(currentFiles[index].name.indexOf('.') + 1);
            if (files.value.findIndex(item => item.file.name.substring(item.file.name.indexOf('.') + 1).toLowerCase() == fileExtension.toLowerCase()) < 0) {
              files.value.push({
                file: currentFiles[index],
                image_path: URL.createObjectURL(currentFiles[index]),
              });
            }
          }
        }
        if (currentFiles[index].type.indexOf('pdf') > 0) {
          displayCompressPDF.value = true;
        }
      }
    };

    const onRemoveImage = (event) => {
      files.value.splice(
        files.value.findIndex((c) => c.file === event.file),
        1
      );
    };

    const displayMaxFileAlert = ref(false);
    const displayMaxSizeFileAlert = ref(false);
    const displayMaxFileSendNewsAlert = ref(false);
    const displayCompressPDF = ref(false);

    const {
      form,
      files,
      compressPdf,
      onSubmit,
      fetchDetail,
      onBackPage,
    } = useImageLibRegister();

    return {
      form,
      files,
      compressPdf,
      onSubmit,
      fetchDetail,
      openSelectFile,
      onSelectedFileImage,
      onBackPage,
      onRemoveImage,
      displayMaxFileAlert,
      displayMaxSizeFileAlert,
      displayMaxFileSendNewsAlert,
      displayCompressPDF,
    };
  },
};
</script>
